import { createContext } from 'react';
export const PaywallModalsContext = createContext(null);
PaywallModalsContext.displayName = 'PaywallModalsContext';
//# sourceMappingURL=PaywallModalsContext.js.map